import { Box, Collapse } from '@mui/material'
import { timelineAnnouncementText, timelineHeaderLabel } from '@/features/chat/phase1/timelineHeaderLabel'
import TimelineAnnouncement from './TimelineAnnouncement'
import TimelineHeader from './TimelineHeader'
import TimelineProcessContent from './TimelineProcessContent'

export default function ActivityTimelineBody({
  model,
  streaming,
  open,
  onToggle,
  publicActivity,
  citations = [],
}) {
  const label = timelineHeaderLabel({
    streaming,
    duration: model.duration,
    summary: model.summary,
  })
  const announcement = timelineAnnouncementText({
    streaming,
    duration: model.duration,
    summary: model.summary,
  })
  return (
    <Box sx={{ mb: 1 }}>
      <TimelineAnnouncement>{announcement}</TimelineAnnouncement>
      <TimelineHeader
        expanded={open}
        streaming={streaming}
        label={label}
        onToggle={onToggle}
      />
      <Collapse in={open}>
        <TimelineProcessContent
          model={model}
          streaming={streaming}
          publicActivity={publicActivity}
          citations={citations}
        />
      </Collapse>
    </Box>
  )
}
